<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    lock-scroll
    append-to-body
  >
    <div class="content">
      <div class="filter-box">
        <el-input v-model="filter.accountName" placeholder="登录账号" class="filter-box__input"></el-input>
        <el-input v-model="filter.userName" placeholder="用户名称" class="filter-box__input"></el-input>
        <el-input v-model="filter.email" placeholder="登录邮箱" class="filter-box__input"></el-input>
        <el-button @click="$_search" class="search__btn">查询</el-button>
        <el-button @click="$_reset" class="reset__btn">重置</el-button>
      </div>
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="table"
        v-loading="isLoading"
        :data="dataList"
        height="456"
        highlight-current-row
        @current-change="$_changeSelected"
        stripe
        tooltip-effect="dark"
      >
        <el-table-column width="50">
          <template slot-scope="scope">
            <el-radio :label="scope.row.uid" :value="currentUserId">
              <span></span>
            </el-radio>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>

        <div class="table-list__empty small" slot="empty"></div>
      </el-table>

      <div class="pagination__wrapper">
        <cd-pagination
          ref="pager"
          :total="pagination.total"
          :currPage="pagination.pageNow"
          :pageSize="pagination.pageSize"
          @changepage="$_changeCurrent"
          @changesize="$_changeSize"
          :explainShow="false"
          @refresh="$_getDataList"
        ></cd-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import handlePagination from "@/mixins/handlePagination";

const columns = [
  { key: "accountName", label: "登录账号" },
  { key: "userName", label: "用户名称" },
  { key: "email", label: "登录邮箱" },
];
export default {
  name: "modal-select-account",
  mixins: [handlePagination],
  props: {
    title: { type: String, default: "" },
    selected: { type: Object, default: {} }, // { userId, userName }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      filter: {
        accountName: "", // 	登录账号
        userName: "", // 用户名称
        email: "", // 登录邮箱
      },
      selectedAccount: {},
      columns,
      dataList: [],
    };
  },
  computed: {
    currentUserId() {
      if (Object.keys(this.selectedAccount).length) {
        return this.selectedAccount.uid;
      }
      return 0;
    },
  },
  methods: {
    // 搜索按钮
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getDataList();
    },
    // 重置
    $_reset() {
      for (const key in this.filter) {
        this.filter[key] = "";
      }
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getDataList();
    },
    // 查询数据列表
    $_getDataList() {
      if (this.isLoading) return false;
      this.isLoading = true;
      let { accountName, userName, email } = this.filter;
      let { pageNow, pageSize } = this.pagination;
      this.$service
        .post("getUsers", { accountName, userName, email, pageNow, pageSize })
        .then((result) => {
          if (result.$.checkResult(result, true)) {
            let { pages, total, rows } = result.data;
            this.pagination.pages = pages;
            this.pagination.total = total;
            this.dataList = rows.concat([]);
          }
          this.isLoading = false;
        });
    },
    // 选中行变化
    $_changeSelected(row) {
      if (row) {
        this.selectedAccount = { ...row };
      } else {
        this.selectedAccount = {};
      }
    },
    // 保存按钮
    $_submit() {
      this.$emit("callback", { ...this.selectedAccount });
      this.$_cancle();
    },
    // 取消
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
  },
  created() {
    this.$_getDataList();
    if (Object.keys(this.selected).length > 0) {
      let { userId: uid, userName: accountName } = this.selected;
      this.selectedAccount = {
        uid,
        accountName,
      };
    }
  },
  mounted() {
    this.visible = true;
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 10px 30px 15px;
  overflow: hidden;
}
.filter-box {
  position: relative;
  height: 60px;
  border: 1px solid #eee;
  background-color: #f5f6f7;
  padding: 0 14px;
  display: flex;
  justify-content: left;
  align-items: center;
  &__input {
    width: 110px;
    margin-right: 10px;
  }
}
.table-list__box {
  border: 1px solid #eee;
  margin-top: -1px;
  background-color: #f9f9f9;
}
</style>
